import { apiClient as baseApiClient } from '#/api/client.tsx';
import type { HighwayMaintenanceFeePenaltyTicket } from '../model';

const hmfpApiClient = baseApiClient.create({
  baseURL: `${import.meta.env.VITE_BASE_URL}/cockpit/auto-pay`,
});

const ENROLLMENT_BASE = '/highway-maintenance-fee-penalty-auto-pay-enrollments';

type YYYYMMDD = string;
type ISODateTime = string;

type ScheduleEnrollmentsBody = {
  scheduledDate: YYYYMMDD;
};

export enum ScheduledStateEnum {
  SCHEDULED = 'SCHEDULED',
  EXECUTED = 'EXECUTED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

type ScheduleEnrollmentsResponse = {
  id: string;
  hmfpAutoPayEnrollmentId: HighwayMaintenanceFeePenaltyTicket['hmfpAutoPayEnrollmentId'];
  scheduledDate: YYYYMMDD;
  state: ScheduledStateEnum;
  creator: string;
  executedTicketId: string | null;
  reason: string | null;
  createDateTime: ISODateTime;
  updateDateTime: ISODateTime;
};

export const scheduleEnrollments = (
  enrollmentId: HighwayMaintenanceFeePenaltyTicket['hmfpAutoPayEnrollmentId'],
  body: ScheduleEnrollmentsBody,
) => {
  return hmfpApiClient
    .post<{
      data: ScheduleEnrollmentsResponse;
    }>(`${ENROLLMENT_BASE}/${enrollmentId}/ticket-schedules`, body)
    .then((res) => res.data.data);
};

type DeleteScheduleResponse = {
  id: string;
  state: ScheduledStateEnum;
  reason: string | null;
  updateDateTime: ISODateTime;
};

export const deleteScheduledEnrollments = ({
  enrollmentId,
  scheduleId,
}: {
  enrollmentId: HighwayMaintenanceFeePenaltyTicket['hmfpAutoPayEnrollmentId'];
  scheduleId: string;
}) => {
  return hmfpApiClient
    .delete<{
      data: DeleteScheduleResponse;
    }>(`${ENROLLMENT_BASE}/${enrollmentId}/ticket-schedules/${scheduleId}`)
    .then((res) => res.data.data);
};
